<template>
  <div class="vuetify-wrapper">
    <v-row elevation="1" class="v-application v-application--is-ltr m-0">
      <v-col cols="12">
        <v-tabs v-model="tab" show-arrows>
          <v-tab>Apo favorisieren FB</v-tab>
          <v-tab>FBs Favoriten</v-tab>
          <v-tab>auf Negativliste von Apos</v-tab>
        </v-tabs>

        <v-tabs-items v-model="tab" class="mt-3">
          <pharmacists-favorites-tab-item
            :items="favoritedByPharmacies"
            :loading="loading"
            empty-text="Keine Einträge"
            :mutual-ids="mutualIds"
          />

          <pharmacists-favorites-tab-item
            :items="favoritesByPharmacist"
            :loading="loading"
            empty-text="Keine Favoriten vorhanden"
            :mutual-ids="mutualIds"
          />

           <pharmacists-favorites-tab-item
            :items="blacklistedByPharmacies"
            :loading="loading"
            empty-text="Keine Favoriten vorhanden"
            :mutual-ids="mutualIds"
          />
        </v-tabs-items>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import PharmacistsFavoritesTabItem from "./PharmacistsFavoritesTabItem.vue";

export default {
  name: "PharmacistsFavorites",
  components: { PharmacistsFavoritesTabItem },

  props: ["admin_id", "pharmacist_id"],

  data() {
    return {
      tab: 0,
      loading: false,
      favoritesByPharmacist: [],
      favoritedByPharmacies: [],
      blacklistedByPharmacies: [],
    };
  },

  computed: {
    favoritesByPharmacistIds() {
      return new Set(this.favoritesByPharmacist.map(p => String(p._id)));
    },
    favoritedByIds() {
      return new Set(this.favoritedByPharmacies.map(p => String(p._id)));
    },
    negativlistByPharmacistIds() {
      return new Set(this.blacklistedByPharmacies.map(p => String(p._id)));
    },
    mutualIds() {
      const ids = new Set();

      this.favoritesByPharmacistIds.forEach(id => {
        if (this.favoritedByIds.has(id)) {
          ids.add(id);
        }
      });

      return ids;
    },
  },

  methods: {
    async load() {
      if (!this.pharmacist_id) return;

      this.loading = true;
      try {
        const [a, b, c] = await Promise.all([
          fetch(`/api/pharmacist/${this.pharmacist_id}/favorites/pharmacies`).then(r => r.json()),
          fetch(`/api/pharmacist/${this.pharmacist_id}/favorited-by/pharmacies`).then(r => r.json()),
          fetch(`/api/pharmacist/${this.pharmacist_id}/blacklisted-by/pharmacies`).then(r => r.json()),
        ]);

        this.favoritesByPharmacist = Array.isArray(a) ? a : [];
        this.favoritedByPharmacies = Array.isArray(b) ? b : [];
        this.blacklistedByPharmacies = Array.isArray(c) ? c : [];
      } catch (e) {
        console.error(e);
        this.favoritesByPharmacist = [];
        this.favoritedByPharmacies = [];
        this.blacklistedByPharmacies = [];
      } finally {
        this.loading = false;
      }
    },
  },

  created() {
    this.load();
  },

  watch: {
    pharmacist_id() {
      this.load();
    },
  },
};
</script>

<style scoped>
.vuetify-wrapper {
  width: 100%;
}
</style>
